import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtTxt from "../Components/CustomTool/CtTxt";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtCmbEditable from "../Components/CustomTool/CtCmbEditable";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import CollapsibleTable from "../Components/CustomTool/CollapsibleTable";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RefreshIcon from "@mui/icons-material/Refresh";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import DeleteIcon from "@mui/icons-material/Delete";
import MailIcon from "@mui/icons-material/Mail";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Link from "@mui/material/Link";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import AMCFollowUpList from "./AMCFollowUpList";
import AMCFollowUpEntry from "./AMCFollowUpEntry";
import AMCGetLocation from "./AMCGetLocation";
import AMCRevise from "./AMCRevise";
import AMCLost from "./AMCLost";
import AMCMailPreview from "./AMCMailPreview";
import AMCBlock from "./AMCBlock";
import AMCUnblock from "./AMCUnblock";
import Final from "./Final";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Box, Breadcrumbs, Typography } from "@mui/material";
import { getRowOfRT, getRowOfRTMuliti } from "../SystemUtility/SystemUtility";
import { ReceiptLong } from "@mui/icons-material";
// import AMCReceipt from "./AMCReceipt";

class AMCRegistration extends Component {
  state = {
    formData: {
      bint_srno: 1,
      cmbBranch: "",
      cmbServiceLocation: "",
      txtSiteName: "",
      txtSiteAddress: "",
      txtLatitude: "",
      txtLongitude: "",
      cmbApproach: "",
      cmbPriority: "",
      txtRemark: "",
    },
    Branches: [],
    ServiceLocations: [],
    ApproachList: [{ name: "EASY" }, { name: "MEDIUM" }, { name: "DIFFICULT" }],
    PriorityList: [{ name: "HIGH" }, { name: "MEDIUM" }, { name: "LOW" }],
    ARD: null,
    contractColumns: [
      { accessorKey: "documentNo", header: "Document No" },
      { accessorKey: "contractType", header: "Contract Type" },
      { accessorKey: "totalLifts", header: "Total Lifts", align: "center" },
      { accessorKey: "totalAmount", header: "Total Amount", align: "right" },
      { accessorKey: "payment", header: "Payment" },
      { accessorKey: "contractStage", header: "Contract Stage" },
    ],
    contractDetailColumns: [
      { accessorKey: "name", header: "Lift Name" },
      { accessorKey: "code", header: "Lift Code" },
      {
        accessorKey: "yearlyService",
        header: "Yearly Lift Service",
        align: "center",
      },
      { accessorKey: "amount", header: "Contract Amount", align: "right" },
    ],
    contractRows: [
      {
        allAction: true,
        documentNo: "TOP/AMC/BVN/25-26/03",
        contractType: "Popular",
        totalLifts: 2,
        totalAmount: "2,20,000",
        payment: "Advance",
        contractStage: "Follow Up",
        lifts: [
          {
            block: true,
            name: "Lift A",
            code: "BVN11060004",
            yearlyService: 12,
            amount: "1,00,000",
          },
          {
            block: false,
            name: "Lift B",
            code: "BVN11060005",
            yearlyService: 14,
            amount: "1,20,000",
          },
        ],
      },
      {
        allAction: false,
        documentNo: "TOP/AMC/BVN/25-26/04",
        contractType: "Regular",
        totalLifts: 2,
        totalAmount: "1,50,000",
        payment: "Advance",
        contractStage: "Final",
        lifts: [
          {
            block: false,
            name: "Lift C",
            code: "BVN11060006",
            yearlyService: 10,
            amount: "75,000",
          },
          {
            block: false,
            name: "Lift D",
            code: "BVN11060007",
            yearlyService: 12,
            amount: "75,000",
          },
        ],
      },
    ],
  };

  componentDidMount() {
    document.title = "AMC Registration";
    localStorage.setItem("Heading", "AMC Registration");

    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("cmbBranch").focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  clearInfo = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        // bint_srno: 0,
        cmbBranch: "",
        cmbServiceLocation: "",
        txtSiteName: "",
        txtSiteAddress: "",
        txtLatitude: "",
        txtLongitude: "",
        cmbApproach: "",
        cmbPriority: "",
        txtRemark: "",
      },
      ARD: null,
    });
    document.getElementById("cmbBranch").focus();
  };

  validationAMCRegistration = () => {
    const {
      cmbBranch,
      cmbServiceLocation,
      txtSiteName,
      txtSiteAddress,
      txtLatitude,
      txtLongitude,
      cmbApproach,
      cmbPriority,
    } = this.state.formData;

    if (!cmbBranch) {
      this.props.toastErrorMsg("Select Branch Name", "cmbBranch");
      return false;
    }
    // if (!cmbServiceLocation) {
    //   this.props.toastErrorMsg("Select Service Location", "cmbServiceLocation");
    //   return false;
    // }
    if (!txtSiteName) {
      this.props.toastErrorMsg("Enter Site Name", "txtSiteName");
      return false;
    }
    if (!txtSiteAddress) {
      this.props.toastErrorMsg("Enter Site Address", "txtSiteAddress");
      return false;
    }
    if (!txtLatitude) {
      this.props.toastErrorMsg("Enter Latitude", "txtLatitude");
      return false;
    }
    if (!txtLongitude) {
      this.props.toastErrorMsg("Enter Longitude", "txtLongitude");
      return false;
    }
    if (!cmbApproach) {
      this.props.toastErrorMsg("Select Site Approachanility", "cmbApproach");
      return false;
    }
    if (!cmbPriority) {
      this.props.toastErrorMsg(
        "Select Priority Of Service & Call Back",
        "cmbPriority",
      );
      return false;
    }
    return true;
  };

  saveAMCRegistration = () => {
    if (this.validationAMCRegistration()) {
      this.props.toastMsg("success", "AMC Registration Save Successfully");
      // this.setState({
      //   formData: {
      //     ...this.state.formData,
      //     bint_srno: 1,
      //   },
      // });
      this.clearInfo();
    }
  };
  handleonClickDeleteContract = (rtRow) => {
    const contractNo = rtRow && rtRow.documentNo ? rtRow.documentNo : undefined;
    this.DeleteContractData(contractNo);
  };
  handleonClickDeleteLift = (rtRow, detailRow) => {
    const liftCode =
      detailRow && detailRow.code
        ? detailRow.code
        : rtRow && rtRow.code
          ? rtRow.code
          : undefined;
    this.DeleteLiftData(liftCode);
  };

  DeleteData = (bint_srno, vac_clientname) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_clientname} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteAMCRegistration(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteAMCRegistration = () => {
    this.props.toastMsg("success", "AMC Registration Delete Successfully");
    this.clearInfo();
  };

  DeleteLiftData = (LiftCode) => {
    if (LiftCode) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${LiftCode} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLift(LiftCode);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteLift = () => {
    this.props.toastMsg("success", "Lift Delete Successfully");
    this.clearInfo();
  };

  DeleteContractData = (ContractNO) => {
    if (ContractNO) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${ContractNO} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteContract(ContractNO);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteContract = () => {
    this.props.toastMsg("success", "AMC Contract Delete Successfully");
    this.clearInfo();
  };

  openARD = (heading, content) => {
    this.setState({ ARD: null }, () => {
      const ARD = (
        <AlertResponsiveDialog
          alertHeading={heading}
          labelDisagree="Close"
          alertMessage={content}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            document.title = "AMC Registration";
            localStorage.setItem("Heading", "AMC Registration");
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  openFollowUpList = () => {
    this.openARD("Follow Up List", <AMCFollowUpList />);
  };

  openFollowUpEntry = () => {
    this.openARD("Follow Up Entry", <AMCFollowUpEntry />);
  };

  openGetLocation = () => {
    this.openARD("Get Location", <AMCGetLocation />);
  };

  openReviseAMC = () => {
    this.openARD("Revise AMC", <AMCRevise />);
  };

  openLostAMC = () => {
    this.openARD("Lost AMC", <AMCLost />);
  };

  openMailPreview = () => {
    this.openARD("Mail Preview", <AMCMailPreview />);
  };

  openBlockAMC = () => {
    this.openARD("Block AMC", <AMCBlock />);
  };

  openFinalPayment = () => {
    this.openARD("Final Advance Payment AMC", <Final />);
  };

  handleRemoveFromFinal = (rtRow) => {
    const contractNo = rtRow && rtRow.documentNo ? rtRow.documentNo : undefined;
    if (contractNo) {
      this.props.toastMsg(
        "success",
        `Removed From Final Successfully : ${contractNo}`,
      );
    } else {
      this.props.toastMsg("success", "Removed From Final Successfully");
    }
  };

  openUnblockAMC = () => {
    this.openARD("Unblock AMC", <AMCUnblock />);
  };
  // openReceipt = () => {
  //   this.openARD("Receipt", <AMCReceipt />);
  // };
  render() {
    const { formData } = this.state;

    return (
      <form>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCList">
            AMC List
          </Link>
          <Typography sx={{ color: "text.primary" }}>
            AMC Registration
          </Typography>
        </Breadcrumbs>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems={"center"}
          marginTop={2}
          spacing={2}
        >
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-start">
              <Grid item>
                <Typography sx={{ color: "text.primary", bold: true }}>
                  Site Info
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveAMCRegistration}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtSiteName,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbBranch"
              label="Branch Name*"
              items={this.state.Branches}
              colID="vac_brname"
              value={formData.cmbBranch}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              nextCtrlID={"cmbServiceLocation"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtCmbEditable
              id="cmbServiceLocation"
              label="Service Location"
              items={this.state.ServiceLocations}
              colID="vac_servicelocation"
              value={formData.cmbServiceLocation}
              handleOnChange={this.handleOnChange}
              maxLength={100}
              width={220}
              nextCtrlID={"txtLongitude"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtTxt
              id="txtSiteName"
              label="Site Name*"
              value={formData.txtSiteName}
              handleOnChange={this.handleOnChange}
              maxLength={100}
              width={220}
              nextCtrlID={"txtSiteAddress"}
              onKeyDown={this.props.onKeyDown}
              disabled={true}
            />
          </Grid>
          <Grid item xs container justifyContent="flex-end">
            <CtBtn
              label="Follow Up"
              className="secondary-button"
              onClick={() => {
                if (this.props.navigate) {
                  this.props.navigate("/AMCFollowUpList");
                }
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtMultiLineText
              id="txtSiteAddress"
              label="Site Address*"
              value={formData.txtSiteAddress}
              handleOnChange={this.handleOnChange}
              width={320}
              maxLength={1000}
              nextCtrlID={"txtLatitude"}
              onKeyDown={this.props.onKeyDown}
              disabled={true}
            />
          </Grid>

          <Grid item>
            <CtTxt
              id="txtLatitude"
              label="Latitude*"
              value={formData.txtLatitude}
              handleOnChange={this.handleOnChange}
              width={180}
              nextCtrlID={"txtLongitude"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtTxt
              id="txtLongitude"
              label="Longitude*"
              value={formData.txtLongitude}
              handleOnChange={this.handleOnChange}
              width={180}
              nextCtrlID={"cmbApproach"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtBtn
              label="Get Location"
              className={"child-button"}
              variant={"outlined"}
              onClick={this.openGetLocation}
              firstletterBig={false}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbApproach"
              label="Site Approachanility*"
              items={this.state.ApproachList}
              colID="name"
              value={formData.cmbApproach}
              handleOnChange={this.handleOnChange}
              maxLength={100}
              width={220}
              nextCtrlID={"cmbPriority"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtCmbEditable
              id="cmbPriority"
              label="Priority Of Service & Call Back*"
              items={this.state.PriorityList}
              colID="name"
              value={formData.cmbPriority}
              handleOnChange={this.handleOnChange}
              maxLength={100}
              width={280}
              nextCtrlID={"txtRemark"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={formData.txtRemark}
              handleOnChange={this.handleOnChange}
              maxLength={100}
              width={320}
            />
          </Grid>

          <Grid item xs container justifyContent="flex-end">
            <CtBtn
              label="Add Contract"
              iconName="new"
              onClick={() =>
                this.props.navigateTo("ContractDetail", {
                  contract: "New Contract",
                })
              }
              firstletterBig={false}
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            p: 3,
            borderBottom: "2px solid #000",
            backgroundColor: "#fff",
          }}
        >
          <Grid container spacing={4}>
            {/* Left Section */}
            <Grid item>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "0.8rem",
                }}
              >
                Billing Name*
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
                Naimish Construction
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "0.8rem",
                }}
              >
                Pan No.
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                ABCDE1234F
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "0.8rem",
                }}
              >
                Billing Address*
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
                Plot No. 22, Sai Darshan park, Shubhashnagar, Ruva Gam,
                Bhavnagar, Gujarat - 364001, GST No. 24AOXPP7835H1Z7
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "0.8rem",
                }}
              >
                GST No.
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                08ABCDE9999F1Z8
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={2}
        >
          <Grid item className="maintable">
            <CollapsibleTable
              columnsdata={this.state.contractColumns}
              rowsdata={this.state.contractRows}
              detailColumnsdata={this.state.contractDetailColumns}
              detailRowKey="lifts"
              menuActions={(row) =>
                row && row.allAction
                  ? [
                      {
                        label: "Print",
                        icon: <PrintIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "PDF",
                        icon: <PictureAsPdfIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "Revise",
                        icon: <RefreshIcon />,
                        onClick: this.openReviseAMC,
                      },
                      {
                        label: "Edit Contract",
                        icon: <DescriptionIcon />,
                        onClick: () => {
                          if (this.props.navigate) {
                            this.props.navigateTo("ContractDetail", {
                              contract: "Existing AMC",
                            });
                          }
                        },
                      },
                      {
                        label: "Final",
                        icon: <CheckCircleIcon />,
                        onClick: this.openFinalPayment,
                      },
                      {
                        label: "WhatsApp",
                        icon: <WhatsAppIcon sx={{ color: "#25D366" }} />,
                        onClick: () => {},
                      },
                      {
                        label: "Follow Up",
                        icon: <FollowTheSignsIcon />,
                        onClick: () => {
                          if (this.props.navigate) {
                            this.props.navigate("/AMCFollowUpList");
                          }
                        },
                      },
                      {
                        label: "Lost",
                        icon: <ReportProblemIcon sx={{ color: "#ff9800" }} />,
                        onClick: this.openLostAMC,
                      },
                      {
                        label: "Delete",
                        icon: <DeleteIcon sx={{ color: "#d32f2f" }} />,
                        onClick: this.handleonClickDeleteContract,
                      },
                      {
                        label: "Mail",
                        icon: <MailIcon />,
                        onClick: this.openMailPreview,
                      },
                      {
                        label: "Receipt",
                        icon: <ReceiptLong />,
                        onClick: this.openReceipt,
                      },
                    ]
                  : [
                      {
                        label: "Print",
                        icon: <PrintIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "PDF",
                        icon: <PictureAsPdfIcon />,
                        onClick: () => {},
                      },
                      {
                        label: "WhatsApp",
                        icon: <WhatsAppIcon sx={{ color: "#25D366" }} />,
                        onClick: () => {},
                      },
                      {
                        label: "Remove From Final",
                        icon: (
                          <RemoveCircleOutlineIcon sx={{ color: "#d32f2f" }} />
                        ),
                        onClick: this.handleRemoveFromFinal,
                      },
                    ]
              }
              liftRowActions={[
                {
                  label: "Edit",
                  icon: <EditIcon fontSize="small" />,
                  onClick: () => {
                    this.props.navigateTo("AMCLiftInfo");
                  },
                },
                {
                  label: "Delete",
                  icon: <DeleteIcon fontSize="small" />,
                  color: "#d32f2f",
                  onClick: this.handleonClickDeleteLift,
                },
                {
                  label: (detailRow) =>
                    detailRow && detailRow.block ? "Block" : "Unblock",
                  icon: (detailRow) =>
                    detailRow && detailRow.block ? (
                      <BlockIcon fontSize="small" />
                    ) : (
                      <LockOpenIcon fontSize="small" />
                    ),
                  onClick: (rtRow, detailRow) => {
                    if (detailRow && detailRow.block) {
                      this.openBlockAMC();
                      return;
                    }
                    this.openUnblockAMC();
                  },
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <div style={{ textAlign: "right" }}>{this.state.ARD}</div>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCRegistration {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
